import { BaseMapper } from '@ps/utils';
import { GetQuestionApiResponseDto } from '../dtos/questions.dto';
import { Question } from '../../models/question.model';

export class QuestionsMapper extends BaseMapper<
  GetQuestionApiResponseDto,
  Question
> {
  public fromDto(dto: GetQuestionApiResponseDto): Question {
    return {
      attributeId: String(dto.qualification_id?.[0] ?? ''),
      desc: dto.question_description,
      category: (dto.question_category ?? []).map((c) => ({
        id: c.id,
        label: c.label,
      })),
      tags: (dto.question_tags ?? []).join(', '),
      locales: dto.locale ?? [],
      class: dto.class,
    };
  }
}
